import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

import { GLTFModel } from '@tresjs/cientos';
import {computed} from 'vue';
import type { PropType } from 'vue';
import {Euler, Quaternion} from 'three';

/**
 * Note: assuming that compass camera is looking in the negative Z direction
 */


export default /*@__PURE__*/_defineComponent({
  __name: 'CompassObject',
  props: {
    sundialCameraQuaternion: {
        required: false,
        type: Object as PropType<Quaternion>
    }
},
  setup(__props) {

const props = __props

const constCompassQuaternion = new Quaternion().setFromEuler(new Euler(0, Math.PI, 0, "XYZ"))

const quaternion = computed(() => {
    if (!props.sundialCameraQuaternion) return new Quaternion()
    return props.sundialCameraQuaternion.clone().invert()
        .multiply(constCompassQuaternion)
})


return (_ctx: any,_cache: any) => {
  const _component_TresObject3D = _resolveComponent("TresObject3D")!

  return (_openBlock(), _createBlock(_component_TresObject3D, { quaternion: quaternion.value }, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_Suspense, null, {
        default: _withCtx(() => [
          _createVNode(_unref(GLTFModel), { path: "./objects3d/compass.glb" })
        ]),
        _: 1
      }))
    ]),
    _: 1
  }, 8, ["quaternion"]))
}
}

})